/*
 * Ingredients catalogue browser (/pages/ingredients) — browse-only sibling of
 * the BYO picker. Fetches the SAME App-Proxy catalogue feed, applies the SAME
 * filter semantics (sort / categories / popularity / used-for + search + A–Z
 * letter groups), but renders big image-led cards that link to each
 * ingredient's PDP. No pricing, no add-to-stack.
 *
 * Images + PDP urls come from a Liquid-emitted slug map (the our-ingredients
 * collection), so the page never fans out per-product requests. Ingredients
 * whose product has no photo yet render an initial tile — as photos are
 * uploaded to the Shopify products they appear here automatically.
 */
(function () {
  var root = document.querySelector('[data-yt-ingredients]');
  if (!root) return;

  var proxyBase = root.dataset.proxyBase || '/apps/yutrients';
  var grid = root.querySelector('[data-yt-ing-grid]');
  var status = root.querySelector('[data-yt-ing-status]');
  var countEl = root.querySelector('[data-yt-ing-count]');
  var searchEl = root.querySelector('[data-yt-ing-search]');
  var azRail = root.querySelector('[data-yt-ing-az]');
  var filtersBody = root.querySelector('[data-yt-ing-filters-body]');

  // slug → { url, img } from the collection (may be empty if collection unset).
  var imageMap = {};
  try {
    var mapEl = root.querySelector('[data-yt-ing-images]');
    if (mapEl) imageMap = JSON.parse(mapEl.textContent) || {};
  } catch (e) { imageMap = {}; }

  // ─── Filter model — mirrors yt-byo.js FILTER_GROUPS ───────────────────────
  var FILTER_GROUPS = [
    {
      id: 'sort', label: 'Sort by', type: 'radio',
      options: [
        { value: 'alpha', label: 'Alphabetical (A–Z)' },
        { value: 'popular', label: 'Most Popular' }
      ]
    },
    {
      id: 'category', label: 'Categories', type: 'checkbox',
      options: [
        { value: 'vitamin', label: 'Vitamins' },
        { value: 'mineral', label: 'Minerals' },
        { value: 'amino_acid', label: 'Amino Acids' },
        { value: 'botanical', label: 'Botanicals & Adaptogens' },
        { value: 'mushroom', label: 'Mushrooms' },
        { value: 'omega', label: 'Omegas & Fatty Acids' },
        { value: 'probiotic', label: 'Probiotics & Digestive' },
        { value: 'longevity', label: 'Longevity & Other' }
      ]
    },
    {
      id: 'popularity', label: 'Popularity', type: 'checkbox',
      options: [
        { value: 'most_popular', label: 'Most Popular' },
        { value: 'trending', label: 'Trending' },
        { value: 'frequently_used', label: 'Frequently Used' },
        { value: 'beginner_friendly', label: 'Beginner Friendly' },
        { value: 'advanced_only', label: 'Advanced Only' }
      ]
    }
  
  ];

  var state = {
    ingredients: [],
    sort: 'alpha',
    category: new Set(),
    popularity: new Set(),
    used_for: new Set(),
    q: ''
  };

  // ─── Fetch the catalogue (same endpoint + timeout pattern as BYO) ─────────
  function fetchWithTimeout(resource, ms) {
    var ctrl = new AbortController();
    var t = setTimeout(function () { ctrl.abort(); }, ms);
    return fetch(resource, { signal: ctrl.signal }).finally(function () { clearTimeout(t); });
  }

  fetchWithTimeout(proxyBase + '/catalogue', 20000)
    .then(function (r) {
      if (!r.ok) throw new Error('catalogue ' + r.status);
      return r.json();
    })
    .then(function (payload) {
      state.ingredients = (payload && payload.ingredients) || [];
      status.hidden = true;
      grid.hidden = false;
      renderFilters();
      render();
    })
    .catch(function () {
      status.textContent = 'Sorry — the ingredients list didn’t load. Please refresh the page to try again.';
    });

  // ─── Filters UI ────────────────────────────────────────────────────────────
  function renderFilters() {
    var html = '';
    FILTER_GROUPS.forEach(function (g) {
      html += '<div class="yt-ing-filters__group" role="group" aria-label="' + g.label + '"><h3 class="yt-ing-filters__legend">' + g.label + '</h3>';
      if (g.type === 'chips') {
        html += '<div class="yt-ing-filters__chips">';
        g.options.forEach(function (o) {
          html += '<button type="button" class="yt-ing-filters__chip" data-group="' + g.id + '" data-value="' + o.value + '">' + o.label + '</button>';
        });
        html += '</div>';
      } else {
        g.options.forEach(function (o) {
          var checked = g.type === 'radio' && o.value === state.sort ? ' checked' : '';
          html +=
            '<label class="yt-ing-filters__option">' +
            '<input type="' + g.type + '" name="yt-ing-' + g.id + '" data-group="' + g.id + '" value="' + o.value + '"' + checked + ' />' +
            '<span>' + o.label + '</span></label>';
        });
      }
      html += '</div>';
    });
    filtersBody.innerHTML = html;

    filtersBody.addEventListener('change', function (e) {
      var el = e.target;
      var group = el.getAttribute('data-group');
      if (!group) return;
      if (group === 'sort') { state.sort = el.value; }
      else {
        var set = state[group];
        if (el.checked) set.add(el.value); else set.delete(el.value);
      }
      render();
    });
    filtersBody.addEventListener('click', function (e) {
      var chip = e.target.closest('.yt-ing-filters__chip');
      if (!chip) return;
      var set = state[chip.getAttribute('data-group')];
      var v = chip.getAttribute('data-value');
      if (set.has(v)) { set.delete(v); chip.classList.remove('is-on'); }
      else { set.add(v); chip.classList.add('is-on'); }
      render();
    });

    var reset = root.querySelector('[data-yt-ing-filters-reset]');
    if (reset) reset.addEventListener('click', function () {
      state.category.clear(); state.popularity.clear(); state.used_for.clear();
      state.sort = 'alpha'; state.q = '';
      if (searchEl) searchEl.value = '';
      renderFilters();
      render();
    });
  }

  // Mobile drawer
  var panel = root.querySelector('[data-yt-ing-filters-panel]');
  var backdrop = root.querySelector('[data-yt-ing-filters-backdrop]');
  var openBtn = root.querySelector('[data-yt-ing-filters-open]');
  var closeBtn = root.querySelector('[data-yt-ing-filters-close]');
  function setDrawer(open) {
    panel.classList.toggle('is-open', open);
    backdrop.hidden = !open;
    if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('yt-ing-noscroll', open);
  }
  if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
  if (backdrop) backdrop.addEventListener('click', function () { setDrawer(false); });

  // Search
  if (searchEl) searchEl.addEventListener('input', function () {
    state.q = searchEl.value.trim().toLowerCase();
    render();
  });


  // ─── Search scoring — PORTED FROM yt-byo.js (founder 2026-08-10: "the
  // search function needs improving like the build your own search bar").
  // Weighted fields, multi-word AND, prefix/substring tiers, typo
  // tolerance (bounded Damerau-Levenshtein), subsequence fallback.
  // Keep the two copies in step if the BYO scorer evolves.
  function searchNormalise(s) {
    return String(s || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }
  function searchField(raw, weight) {
    var text = searchNormalise(raw);
    if (!text) return null;
    return { text: text, words: text.split(' '), weight: weight };
  }
  function buildSearchIndex(items) {
    return items.map(function (it) {
      var fields = [];
      var push = function (f) { if (f) fields.push(f); };
      push(searchField(it.name, 100));
      (it.aliases || []).forEach(function (a) { push(searchField(a, 85)); });
      push(searchField(it.latin_name, 70));
      push(searchField(it.tagline, 55));
      push(searchField(it.category, 40));
      (it.discovery_tags || []).forEach(function (t) { push(searchField(t, 35)); });
      (it.goal_tags || []).forEach(function (t) { push(searchField(t, 35)); });
      return { slug: it.slug, fields: fields };
    });
  }
  function withinEdits(a, b, maxEdits) {
    if (maxEdits <= 0) return a === b;
    if (Math.abs(a.length - b.length) > maxEdits) return false;
    var m = a.length, n = b.length;
    var prevPrev = [], prev = [], j, i;
    for (j = 0; j <= n; j++) prev.push(j);
    for (i = 1; i <= m; i++) {
      var cur = [i];
      var rowMin = i;
      for (j = 1; j <= n; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          v = Math.min(v, prevPrev[j - 2] + 1);
        }
        cur.push(v);
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > maxEdits) return false;
      prevPrev = prev;
      prev = cur;
    }
    return prev[n] <= maxEdits;
  }
  function typoBudget(token) {
    if (token.length >= 8) return 2;
    if (token.length >= 4) return 1;
    return 0;
  }
  function subsequenceScore(token, text) {
    var ti = 0, adjacent = 0, last = -2;
    for (var i = 0; i < text.length && ti < token.length; i++) {
      if (text[i] === token[ti]) {
        if (i === last + 1) adjacent++;
        last = i;
        ti++;
      }
    }
    if (ti < token.length) return 0;
    return 1 + adjacent / Math.max(1, token.length - 1);
  }
  function tokenFieldScore(token, f) {
    if (f.text === token) return 10;
    if (f.text.startsWith(token)) return 6;
    for (var i = 0; i < f.words.length; i++) if (f.words[i].startsWith(token)) return 4.5;
    if (f.text.includes(token)) return 3;
    var budget = typoBudget(token);
    if (budget > 0) {
      for (var j = 0; j < f.words.length; j++) if (withinEdits(token, f.words[j], budget)) return 2.5;
    }
    if (token.length >= 3) {
      var sub = subsequenceScore(token, f.text);
      if (sub > 0) return Math.min(2, sub);
    }
    return 0;
  }
  function searchScores(index, query) {
    var tokens = searchNormalise(query).split(' ').filter(Boolean);
    var out = new Map();
    if (!tokens.length) return out;
    for (var e = 0; e < index.length; e++) {
      var entry = index[e];
      var total = 0;
      var ok = true;
      for (var t = 0; t < tokens.length; t++) {
        var best = 0;
        for (var fI = 0; fI < entry.fields.length; fI++) {
          var tier = tokenFieldScore(tokens[t], entry.fields[fI]);
          if (tier <= 0) continue;
          var sc = tier * entry.fields[fI].weight;
          if (sc > best) best = sc;
        }
        if (best <= 0) { ok = false; break; }
        total += best;
      }
      if (ok) out.set(entry.slug, total);
    }
    return out;
  }
  var searchIndex = null;
  var searchHits = null; // Map(slug → score) for the active query, null = no query

  // ─── Filtering + rendering ────────────────────────────────────────────────
  function passes(i) {
    if (state.category.size > 0 && !state.category.has(i.category)) return false;
    if (state.popularity.size > 0) {
      var d = i.discovery_tags || [];
      var hitD = d.some(function (t) { return state.popularity.has(t); });
      if (!hitD) return false;
    }
    if (state.used_for.size > 0) {
      var g = i.goal_tags || [];
      var hitG = g.some(function (t) { return state.used_for.has(t); });
      if (!hitG) return false;
    }
    if (state.q) {
      // BYO-grade matching: typo-tolerant, word-order-free, alias/tag
      // aware. searchHits is rebuilt once per render() while a query is
      // active; an item passes when the scorer matched it at all.
      if (!searchHits || !searchHits.has(i.slug)) return false;
    }
    return true;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardHtml(i) {
    var meta = imageMap[i.slug] || {};
    var url = meta.url || ('/products/' + i.slug);
    var media = meta.img
      ? '<img class="yt-ing-card__img" src="' + esc(meta.img) + '" alt="' + esc(i.name) + '" loading="lazy" />'
      : '<div class="yt-ing-card__placeholder" aria-hidden="true">' + esc((i.name || '?').charAt(0)) + '</div>';
    // One sub-description per card (founder 2026-07-07): the tagline
    // carries the form/parts info (e.g. "Medicago sativa aerial parts"),
    // so the separate italic latin line was redundant noise.
    var subNorm = function (x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); };
    var sub = i.tagline || i.latin_name || '';
    if (subNorm(sub) === subNorm(i.name)) sub = (sub === i.tagline && i.latin_name) ? i.latin_name : '';
    if (subNorm(sub) === subNorm(i.name)) sub = '';
    return (
      '<a class="yt-ing-card" href="' + esc(url) + '">' +
      '<div class="yt-ing-card__media">' + media + '</div>' +
      '<div class="yt-ing-card__body">' +
      '<h3 class="yt-ing-card__name">' + esc(i.name) + '</h3>' +
      (sub ? '<p class="yt-ing-card__desc">' + esc(sub) + '</p>' : '') +
      '</div></a>'
    );
  }

  function render() {
    if (state.q) {
      if (!searchIndex) searchIndex = buildSearchIndex(state.ingredients);
      searchHits = searchScores(searchIndex, state.q);
    } else {
      searchHits = null;
    }
    var list = state.ingredients.filter(passes);
    if (countEl) countEl.textContent = list.length + ' ingredient' + (list.length === 1 ? '' : 's');

    if (list.length === 0) {
      grid.innerHTML = '<p class="yt-ing__empty">No ingredients match those filters.</p>';
      renderAz([]);
      return;
    }

    var html = '';
    if (state.sort === 'popular') {
      list.sort(function (a, b) {
        return (a.popularity_rank || 9999) - (b.popularity_rank || 9999);
      });
      html = '<div class="yt-ing__cards">' + list.map(cardHtml).join('') + '</div>';
      renderAz([]);
    } else {
      // Founder 2026-07-10: numeric-leading names (5-HTP…) sort AFTER Z,
      // so the '#' group renders at the end and the rail matches.
      var isNum = function (i) { return /[A-Za-z]/.test((i.name || '').charAt(0)) ? 0 : 1; };
      list.sort(function (a, b) {
        var d = isNum(a) - isNum(b);
        if (d !== 0) return d;
        return a.name.localeCompare(b.name);
      });
      var letters = [];
      var current = '';
      var buf = [];
      var sections = [];
      list.forEach(function (i) {
        var L = (i.name.charAt(0) || '#').toUpperCase();
        if (!/[A-Z]/.test(L)) L = '#';
        if (L !== current) {
          if (buf.length) sections.push({ letter: current, cards: buf });
          current = L; buf = []; letters.push(L);
        }
        buf.push(cardHtml(i));
      });
      if (buf.length) sections.push({ letter: current, cards: buf });
      html = sections.map(function (s) {
        return (
          '<div class="yt-ing__letter" id="yt-ing-letter-' + s.letter.replace('#', 'num') + '">' +
          '<h2 class="yt-ing__letter-label">' + s.letter + '</h2>' +
          '<div class="yt-ing__cards">' + s.cards.join('') + '</div></div>'
        );
      }).join('');
      renderAz(letters);
    }
    grid.innerHTML = html;
  }

  function renderAz(present) {
    if (!azRail) return;
    if (!present.length) { azRail.innerHTML = ''; return; }
    var all = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ#'.split('');  /* '#' last — numbers sort after Z */
    azRail.innerHTML = all.map(function (L) {
      var has = present.indexOf(L) !== -1;
      return has
        ? '<button type="button" class="yt-ing__az-letter" data-letter="' + L + '">' + L + '</button>'
        : '<span class="yt-ing__az-letter is-empty">' + L + '</span>';
    }).join('');
    azRail.querySelectorAll('button[data-letter]').forEach(function (b) {
      b.addEventListener('click', function () {
        var el = document.getElementById('yt-ing-letter-' + b.dataset.letter.replace('#', 'num'));
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
})();
